"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _lodash = require("lodash");

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes: {
      customText,
      noTeaser
    }
  } = _ref;
  const moreTag = customText ? `<!--more ${customText}-->` : '<!--more-->';
  const noTeaserTag = noTeaser ? '<!--noteaser-->' : '';
  return (0, _element.createElement)(_element.RawHTML, null, (0, _lodash.compact)([moreTag, noTeaserTag]).join('\n'));
}
//# sourceMappingURL=save.js.map